// eslint-disable-next-line import/prefer-default-export
export const awaitableTimeout = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
